import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { Address } from '../../../../../global/interfaces/address';
import { AddressPipe } from '../../../directives/address/address.pipe';
import { AddressFunctions } from '../../../../../utils/address.functions';
import { MapService } from '../../../../../global/services/map.service';

@Component({
  selector: 'app-ship-from',
  templateUrl: './ship-from-section.component.html',
  styleUrls: ['./ship-from-section.component.less'],
})
export class ShipFromSectionComponent implements OnInit {
  @Input() name: string = '';
  @Input() address: Address = {} as Address;
  @Input() isEdit: boolean;
  @Output() nameChange = new EventEmitter<string>();
  @Output() addressChange = new EventEmitter<Address>();

  suggestions: any[] = [];

  existingAddress = '';
  postCodes: any[] = [];

  isDomesticLoad = false;

  constructor(
    private addressFunctions: AddressFunctions,
    private mapService: MapService,
    private addressPipe: AddressPipe,
  ) {}

  ngOnInit(): void {
    this.existingAddress = this.createAddress(this.address);
  }
  createAddress(address: Address) {
    return this.addressPipe.transform(address);
  }

  async getSuggestions(query: string) {
    this.suggestions = [];
    if (!query) return;
    this.suggestions = await this.mapService.getAddressSuggestions(query);
  }

  async getAddress(object) {
    const address = object.value;
    const emptyAddress: Address = this.addressFunctions.getEmptyOrFormatExistingAddress();
    const fullAddress = address !== '' ? await this.mapService.getFullAddressFromCoordinates(address) : emptyAddress;
    this.address = fullAddress;
    this.existingAddress = this.createAddress(this.address);
    this.addressChange.emit(this.address);

    this.suggestions = [];
    this.postCodes = [];
  }

  async getPostalCodeSuggestions(query: string) {
    if (query !== '') {
      this.postCodes = await this.mapService.getPostalCodeSuggestions(query);
    } else {
      const emptyAddress: Address = this.addressFunctions.getEmptyOrFormatExistingAddress();
      this.address = emptyAddress;
      this.addressChange.emit(this.address);

      this.postCodes = [];
    }
  }

  onNameChange(): void {
    this.nameChange.emit(this.name);
  }
}
